// SimpleLoader.tsx - Fixed version
import React from 'react'

type Prop = {
  className?: string
  showText?: boolean
  position?: 'absolute' | 'relative' | 'fixed'
  text?: string,
  textColor?: string,
  size?: 'small' | 'medium' | 'large'
  showbackdrop?: boolean
  fullScreen?: boolean
}

const SimpleLoader: React.FC<Prop> = ({
  className,
  showText = true,
  position = 'absolute',
  text = 'Loading...',
  textColor = 'text-white',
  size = 'medium',
  showbackdrop = false,
  fullScreen = false
}) => {
  const sizeClass = size === 'small' ? 'w-30px h-30px' : size === 'medium' ? 'w-40px h-40px' : 'w-50px h-50px';

  // For absolute positioning, we need to ensure it doesn't cause overflow
  const positionStyles = position === 'absolute' ? {
    position: 'absolute' as const,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  } : position === 'fixed' ? {
    position: 'fixed' as const,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 9999,
  } : {
    position: 'relative' as const,
  };

  return (
    <div
      style={{
        ...positionStyles,
        zIndex: position === 'fixed' ? 9999 : 9,
        overflow: 'hidden', // Prevents overflow
      }}
      className={`d-flex h-100 w-100 ${textColor} fs-5 flex-center flex-column ${className} ${showbackdrop ? 'bg-black-30' : ''}`}
    >
      <div className={`loader mb-1 ${sizeClass}`}></div>
      {showText && <span>{text}</span>}
    </div>
  )
}

export default SimpleLoader